import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const PaymentErrorDialog = ({ open, setOpen, error }) => {
  const handleClose = () => setOpen(false);
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Error</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Payment failed due to the following reasons:
          <ul style={{ textTransform: 'uppercase', fontWeight: 'bold' }}>
            <li>{error?.decline_code?.replace(/_/g, ' ')}</li>
            <li>{error?.code?.replace(/_/g, ' ')}</li>
          </ul>
          <p>
            Please try with different card. If there is still error please
            contact&nbsp;
            <a href='mailto:customerservice@bigoventeees.com'>
              Big Oven Tees INC (customerservice@bigoventeees.com)
            </a>
            .
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentErrorDialog;
